import types from './types';

const updateSchoolInfo = (data) => ({
	type: types.UPDATE_SCHOOL_INFO,
	payload: data
});


// const updateSearch = info => ({
//   type: types.UPDATE_SEARCH,
//   payload: info
// });

export default {
	updateSchoolInfo,
	// updateSearch
};
